import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App.tsx';
import { initAdsense } from './lib/ads';
import { initAnalytics } from './lib/analytics';
import { hasConsent } from './lib/consent';

// GDPR / ePrivacy: don't load tracking or ads until the visitor has
// accepted cookies. The CookieBanner component re-runs these inits
// inline once the user clicks Accept, so first-visit consent doesn't
// require a page reload. See docs/ads-integration.md for the
// threat-model boundary.
if (hasConsent()) {
  initAnalytics();
  initAdsense();
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('#root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
